import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { Link, useNavigate } from "react-router-dom";
import Col from "react-bootstrap/Col";

import Row from "react-bootstrap/Row";
import Select from "react-select";
import SignUpModal from "./SignUpModal/ContactModal";

import { useContext } from "react";
import { Context } from "../../../../utils/context";
import { getData, postData } from "../../../../utils/api";

function Step1({ handleNext }) {
  const navigate = useNavigate();

  const { recruiterData, setRecruiterData } = useContext(Context);
  const [selectedOption, setSelectedOption] = useState(null);
  const [livingErr, setLivingErr] = useState("");

  const options = [];
  const [cities, setCities] = useState();

  const getCities = async () => {
    const res = await getData("/without-login/master/all-cities");
    if (res?.success) {
      const mergedOptions = [
        ...options,
        ...res.data.map((city) => ({ value: city?.id, label: city?.name })),
      ];

      setCities(mergedOptions);
    }
  };

  useEffect(() => {
    getCities();
  }, []);

  const [nameErr, setNameErr] = useState("");
  const [emailErr, setEmailErr] = useState("");

  console.log(emailErr, "emailErr");

  const [lastNameErr, setlastNameErr] = useState("");
  const [contactNoErr, setContactNoErr] = useState("");
  const [addressErr, setAddressErr] = useState("");

  const handleValidation = async () => {
    var firstname = document.getElementById("firstname").value;
    var email = document.getElementById("email").value;
    var contact_no = document.getElementById("contact_no").value;
    var address = document.getElementById("address").value;

    // Initialize an array to store error messages
    var errors = [];

    if (firstname?.trim() === "") {
      setNameErr("Company Name is required");
      errors.push("Company Name is required");
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (email === "") {
      setEmailErr("Email is required");
      errors.push("Email is required");
    } else if (!emailRegex.test(email)) {
      setEmailErr("Invalid Email format");
      errors.push("Invalid Email format");
    }

    if (contact_no === "") {
      setContactNoErr("Contact Number is required");
      errors.push("Contact Number is required");
    } else if (!/^[0-9]{10}$/.test(contact_no)) {
      setContactNoErr("Enter valid 10 digit number");
      errors.push("Invalid contact number");
    }

    if (address === "") {
      setAddressErr("Current Address is required");
      errors.push("Current Address is required");
    }

    if (selectedOption === null) {
      setLivingErr("Registered Office City is required");
      errors.push("Registered Office City is required");
    }

    console.log(errors, "errors");

    if (errors.length === 0) {
      recruiterData.first_name = firstname;
      recruiterData.current_address = address;
      recruiterData.email = email;
      recruiterData.contact_no = "91" + contact_no;
      recruiterData.living_city_id = selectedOption?.value;

      signUp();
    }
  };

  // const handleTerms = (element) => {
  //   if (element.target.checked) {
  //     // setRecruiterData(true)
  //     recruiterData.policy = true;
  //   } else {
  //     recruiterData.policy = false;
  //     // setRecruiterData(false)
  //   }
  // };
  const handleTerms = (event) => {
    setPolicyErr("");
    setRecruiterData((prevData) => ({
      ...prevData,
      policy: event.target.checked,
    }));
  };
  const [modalShow, setModalShow] = useState(false);
  const [signin, setSignin] = useState(false);
  const [policyErr, setPolicyErr] = useState("");

  const signUp = async () => {
    if (recruiterData.policy == false) {
      setPolicyErr("Accept our Policies for SignUp...!");
    } else {
      const res = await postData(
        `/without-login/recruiters/sign-up`,
        recruiterData,
      );
      if (res?.success) {
        setModalShow(true);
        setSignin(true);
        setTimeout(() => {
          setModalShow(false);
          navigate("/getotp");
        }, 4000);
        //

        // Cookies.set("echohouse_website", res.data.token, { expires: 1 });
        // Cookies.set("jwtType", res.data.type, { expires: 1 });
        // setModalShow(true);
        // setSignin(true);
        // setTimeout(() => {
        //   setModalShow(false);
        //   navigate("/talentPool");
        // }, 4000);
      } else {
        setAddressErr(res?.message);
      }
    }
  };

  return (
    <>
      <fieldset>
        <div className="form-card StepForm-recruiter">
          <div className="row">
            <div className="col-7">
              <h2>
                {/* <span className="blue-line"></span>{" "} */}
                {/* <span className="fs-title">Step1</span> */}
              </h2>
            </div>
          </div>
          <Form>
            <Row className="mb-3">
              <div className="col-md-6">
                <Form.Group as={Col} controlId="formGridCity">
                  <Form.Label>
                    Company Name <span className="text-danger">*</span>{" "}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Company Name"
                    id="firstname"
                    defaultValue={recruiterData && recruiterData?.first_name}
                    onKeyDown={(event) => {
                      if (!/[A-Z-a-z ]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    onChange={() => setNameErr("")}
                  />
                  <span
                    className="text text-danger "
                    style={{
                      textAlign: "center",
                    }}>
                    {nameErr && nameErr}
                  </span>
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group as={Col} controlId="formGridCity">
                  <Form.Label>
                    Email <span className="text-danger">*</span>{" "}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Email"
                    id="email"
                    defaultValue={recruiterData && recruiterData?.email}
                    onKeyDown={(event) => {
                      if (!/[A-Z-a-z ]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    onChange={() => setEmailErr("")}
                  />
                  <span
                    className="text text-danger "
                    style={{
                      textAlign: "center",
                    }}>
                    {emailErr && emailErr}
                  </span>
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group as={Col} controlId="formGridCity">
                  <Form.Label>
                    Contact No <span className="text-danger">*</span>{" "}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    maxLength={10}
                    placeholder="Enter Contact No"
                    id="contact_no"
                    defaultValue={recruiterData?.contact_no}
                    onKeyDown={(event) => {
                      if (
                        !/[0-9]/.test(event.key) &&
                        event.key !== "Backspace"
                      ) {
                        event.preventDefault();
                      }
                    }}
                    onChange={() => setContactNoErr("")}
                  />
                  <span
                    className="text text-danger "
                    style={{
                      textAlign: "center",
                    }}>
                    {contactNoErr && contactNoErr}
                  </span>
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group as={Col} controlId="formGridCity">
                  <Form.Label>
                    Company Address <span className="text-danger">*</span>{" "}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Company Address"
                    id="address"
                    defaultValue={recruiterData && recruiterData?.address}
                    // onKeyDown={(event) => {
                    //   if (!/[0-9]/.test(event.key)) {
                    //     event.preventDefault();
                    //   }
                    // }}
                    onChange={() => setAddressErr("")}
                  />
                  <span
                    className="text text-danger "
                    style={{
                      textAlign: "center",
                    }}>
                    {addressErr && addressErr}
                  </span>
                </Form.Group>
              </div>

              <Row className="mb-3">
                <div className="col-md-6 col-12">
                  <Form.Group className="mb-3" controlId="formGridCity">
                    <Form.Label>
                      Registered Office City
                      <span className="text-danger">*</span>
                    </Form.Label>
                    {/* <Form.Select className="mt-0">
                    <option>Pune</option>
                    <option>Mumbai</option>
                    <option>Hydrabad</option>
                  </Form.Select> */}
                    <Select
                      value={selectedOption}
                      onChange={(selectedOption) => {
                        setSelectedOption(selectedOption);
                        setLivingErr("");
                      }}
                      options={cities}
                      isSearchable={true}
                      id="living"
                    />
                  </Form.Group>
                  <span
                    className="text text-danger"
                    style={{
                      textAlign: "center",
                    }}>
                    {livingErr && livingErr}
                  </span>
                </div>
              </Row>
            </Row>
          </Form>
          <div className="row step1_nameField mt-4">
            <div className="mobile-view-button">
              <button
                type="button"
                name="next"
                className="next action-button contin-btn"
                onClick={handleValidation}>
                Continue
              </button>
            </div>
          </div>
        </div>
      </fieldset>
      <div className="row  mb-4 footer-sec">
        <div className="col-md-10 col-12">
          <div className="check-row text-start">
            <span>
              <input
                type="checkbox"
                name="group1"
                className="me-2"
                onChange={handleTerms}
                checked={recruiterData?.policy || false} // Ensure it doesn't throw errors
              />
            </span>
            <span className=" by-text ">By signing up, I agree to the</span>
            <span className="px-1 ">
              <Link to="/terms" className="term-btn">
                Terms and Conditions
              </Link>
            </span>
            <br />
          </div>
          {policyErr && <div className="text-danger mt-1">{policyErr}</div>}
          <div className="login-row text-start">
            <p>
              <span className="">Already an User?</span>
              <span className="px-1 inner_text">
                <Link to="/getotp" className="login-btn">
                  log In
                </Link>
              </span>
            </p>

            <p>
              <span className="">Not a Recruiter ?</span>
              <span className="px-1 ">
                <Link to="/getotp-jobseeker" className="signup-btn">
                  Signup as Jobseeker
                </Link>
              </span>
            </p>
          </div>
        </div>

        <div className="col-2 ">
          <button
            type="button"
            name="next"
            className="next action-button desktop-view-button"
            onClick={handleValidation}>
            Continue
          </button>
        </div>

        <div>
          <SignUpModal show={modalShow} onHide={() => setModalShow(false)} />
        </div>
      </div>
    </>
  );
}

export default Step1;
